import { useEffect, useState } from "react";
import { Chart, PieSeries } from "@devexpress/dx-react-chart-material-ui";
import { Animation } from "@devexpress/dx-react-chart";
import { Palette } from "@devexpress/dx-react-chart";

import { useHttpClient } from "../../../shared/hooks/httpHook";
import { SaleDash } from "../../../sales/components/SaleDash";
import { TaskDash } from "../../../sales/components/TaskDash";
import { ModalError } from "../../../shared/components/UIElements/ModalError";
import { LoadingSpinnerOverlayRegular } from "../../../shared/components/UIElements/LoadingSpinnerOverlayRegular";
import { HomeDashboardNextSchedulesItem } from "./HomeDashboardNextSchedulesItem";
import { addThousandSeparator } from "../../../shared/util/addThousandSeparator";
import { getMonthNameAndYear } from "../../../shared/util/getMonthNameAndYear";
import { getNextSchedules } from "../../api/analyticsAPI";
import {
  AuthContextProps,
  SettingsContextProps,
  KanbanFilledData,
  NotePopCustData,
} from "../../../shared/data/types";

import "./HomeDashboard.scss";

interface HomeDashboardNextSchedulesProps {
  settingsCtx: SettingsContextProps;
  auth: AuthContextProps;
  fetchId: string;
  loadedData: NotePopCustData[];
  setLoadedData: React.Dispatch<React.SetStateAction<NotePopCustData[]>>;
}

export const HomeDashboardNextSchedules = (
  props: HomeDashboardNextSchedulesProps
) => {
  const { settingsCtx, auth, fetchId, loadedData, setLoadedData } = props;
  const [type, setType] = useState<
    | "SALES"
    | "PROJECT"
    | "INSTALLATION"
    | "AFTER_SALES"
    | "PRE_SALES"
    | "ADMINISTRATIVE"
  >("SALES");
  const [activeNote, setActiveNote] = useState<string>(null);
  const [activeItem, setActiveItem] = useState<string>(null);
  const [kanbanData, setKanbanData] = useState<KanbanFilledData>(null);
  const { error, sendRequest, clearError, isLoading } = useHttpClient();

  useEffect(() => {
    if (!!auth.token) {
      getNextSchedules({
        sendRequest,
        auth,
        setLoadedData,
        fetchId,
        settingsCtx,
      });
    }
  }, [fetchId, auth?.token]);

  const closeSaleDashHandler = () => {
    setActiveItem(null);
  };

  return (
    <div className="dashboard-item dashboard-item--next-schedules">
      {isLoading && <LoadingSpinnerOverlayRegular />}
      {/* <ModalError error={error} onClear={clearError} /> */}
      <p className="dashboard-item__title dashboard-item__title--padded">
        Próximos Itens da Agenda
      </p>
      <div className="dashboard-item__list">
        {loadedData?.map((item, i) => {
          return (
            <HomeDashboardNextSchedulesItem
              item={item}
              key={item._id}
              fetchId={fetchId}
              kanbanData={kanbanData}
              setLoadedData={setKanbanData}
              setActiveItem={setActiveItem}
              setActiveNote={setActiveNote}
              settingsCtx={settingsCtx}
              auth={auth}
              type={type}
              setType={setType}
            />
          );
        })}
      </div>
      {loadedData?.length === 0 && (
        <div className="dashboard-item__no-data">
          <img
            className="dashboard-item__no-data-img"
            src={`${process.env.PUBLIC_URL}/nenhum-dado.png`}
            alt=""
          />
        </div>
      )}
      {(type === "SALES" || type === "AFTER_SALES" || type === "PRE_SALES") &&
        kanbanData && (
          <SaleDash
            type={type}
            auth={auth}
            settingsCtx={settingsCtx}
            active={!!activeItem}
            activeNote={activeNote}
            closeHandler={closeSaleDashHandler}
            loadedItem={kanbanData?.items?.find((item) => {
              return item?.id === activeItem;
            })}
            setLoadedData={setKanbanData}
            setActiveItem={setActiveItem}
            setScheduleData={setLoadedData}
            fetchId={fetchId}
            kanbanData={kanbanData}
          />
        )}
      {(type === "PROJECT" ||
        type === "INSTALLATION" ||
        type === "ADMINISTRATIVE") &&
        kanbanData && (
          <TaskDash
            type={type}
            auth={auth}
            settingsCtx={settingsCtx}
            active={!!activeItem}
            activeNote={activeNote}
            closeHandler={closeSaleDashHandler}
            loadedItem={kanbanData?.items?.find((item) => {
              return item?.id === activeItem;
            })}
            setLoadedData={setKanbanData}
            setActiveItem={setActiveItem}
            setScheduleData={setLoadedData}
            fetchId={fetchId}
            kanbanData={kanbanData}
          />
        )}
    </div>
  );
};
